import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepad: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGamepad"><Path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H23V5H1ZM9 9V11H11V13H9V15H7V13H5V11H7V9H9ZM17.75 11.75C17.0596 11.75 16.5 11.1904 16.5 10.5C16.5 9.80964 17.0596 9.25 17.75 9.25C18.4404 9.25 19 9.80964 19 10.5C19 11.1904 18.4404 11.75 17.75 11.75ZM14.75 14.75C14.0596 14.75 13.5 14.1904 13.5 13.5C13.5 12.8096 14.0596 12.25 14.75 12.25C15.4404 12.25 16 12.8096 16 13.5C16 14.1904 15.4404 14.75 14.75 14.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepad;
